import { ApplicationEvent } from './application-event.model';
import { ApplicationEventType } from '../constants';

export class CartLinkClickApplicationEvent implements ApplicationEvent {
  type = ApplicationEventType.CartLinkClick;

  constructor(private label: string) {}

  getPayload(): any {
    return {
      category: ApplicationEventType.Navigation,
      label: this.label
    };
  }
}
